module.exports = __webpack_public_path__ + "static/testimonial-3-ba419a87336bdd7d7e09e6de8e2d0b12.mp4";